import React from 'react';
import './listOfAPIs.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import TableListApis from "./TableListApis";

const ListOfApIs = ({ data }) => {
  console.log("list of api :", data?.data?.data);

  return (
    <section className="print__api">
      <HeaderPrint
        englishTitle={"List of APIs"}
        persianTitle={"فهرست API ها"}
        color={"#522C87"}
      />
      {data?.data?.data.map((item, index) => (
        <TableListApis key={index} rowNumber={index+1} items={item} />
      ))}
    </section>
  );
};

export default ListOfApIs;
